/**
 * PARA BİRİMİ — TEK KAYNAK
 *
 * ─── İSTEK ───
 * "stok bölümünde veya kasa bölümüne TL dışında euro dolar gibi ödeme
 * yöntemleri ekle, stoktaki alışları da döviz olarak girebileyim, sadece
 * TL üzerine kurulu bir yapı olmasın."
 * "güncel kur yazmaya gerek yok. sadece mesela 400 euro ödeme aldıysam
 * euro seçip girebileyim."
 *
 * ─── KARAR: TL KARŞILIĞI HER ZAMAN YAZILIR ───
 * Her para taşıyan satır ÜÇ alan kazanır:
 *   para_birimi   'TRY' | 'USD' | 'EUR'
 *   doviz_tutar   kullanıcının YAZDIĞI sayı (400)
 *   kur           o andaki TL karşılığı (1 € = 45,60)
 * Var olan `tutar` / `alis_fiyat` / `satis_fiyat` sütunları ise
 * DEĞİŞMEDEN TL karşılığını tutmaya devam eder (400 × 45,60 = 18.240).
 *
 * Nedeni tek cümleyle: raporlar, cari bakiye, kâr hesabı, PDF'ler ve
 * yedekleme bu sütunları okuyor. TL karşılığı yazılmasaydı "net kasa"
 * diye tek bir rakam kalmaz, onlarca yerin hepsi ayrı ayrı elden
 * geçirilirdi — ve bir tanesi unutulsa rakam sessizce yanlış çıkardı.
 * Bu kurulumda döviz BİLGİ OLARAK EKLENİR, hiçbir eski hesabı bozmaz.
 *
 * TRY satırlarda doviz_tutar = tutar ve kur = 1'dir; yani TL de aynı
 * yoldan geçer, ayrı bir dal yoktur.
 */
export const PARA_BIRIMLERI = [
    { kod: 'TRY', simge: '₺', ad: 'Türk lirası' },
    { kod: 'USD', simge: '$', ad: 'ABD doları' },
    { kod: 'EUR', simge: '€', ad: 'Euro' },
];
/** Sistemin iç para birimi. Bütün TL karşılıkları bu cinstendir. */
export const ANA_PARA_BIRIMI = 'TRY';
export const PARA_BIRIMI_KODLARI = PARA_BIRIMLERI.map((p) => p.kod);
/** Yabancı para birimleri — kur gerektirenler. */
export const DOVIZ_KODLARI = PARA_BIRIMI_KODLARI.filter((k) => k !== ANA_PARA_BIRIMI);
export function paraBirimiMi(deger) {
    return typeof deger === 'string' && PARA_BIRIMI_KODLARI.includes(deger);
}
/**
 * Bilinmeyen/boş değer TL sayılır.
 *
 * Göç öncesi yazılmış her satırda `para_birimi` NULL'dur; onları TL kabul
 * etmek doğru cevaptır — o kayıtlar gerçekten TL idi.
 */
export function paraBirimiNormalle(deger) {
    return paraBirimiMi(deger) ? deger : ANA_PARA_BIRIMI;
}
export function paraBirimiSimgesi(deger) {
    const kod = paraBirimiNormalle(deger);
    return PARA_BIRIMLERI.find((p) => p.kod === kod)?.simge ?? '₺';
}
export function paraBirimiAdi(deger) {
    const kod = paraBirimiNormalle(deger);
    return PARA_BIRIMLERI.find((p) => p.kod === kod)?.ad ?? 'Türk lirası';
}
/**
 * TOHUM KURLAR — sistem hiç kur çekemediyse kullanılır.
 *
 * Bir kur uydurmak kötüdür; ama kullanıcıyı "kur yok, döviz giremezsin"
 * diye durdurmak daha kötüdür. Bu yüzden tohum değer VARDIR ama ekranda
 * her zaman tarihiyle ve "tohum" kaynağıyla görünür: bayat bir kur
 * sessiz kalmaz. İlk başarılı TCMB çekişi bunu ezer.
 */
export const TOHUM_KUR = {
    kurlar: { USD: 41.2, EUR: 45.6 },
    tarih: '2026-09-14',
    kaynak: 'tohum',
    guncellendi: '2026-09-14T00:00:00.000Z',
};
/**
 * Bir para biriminin TL karşılığını verir. TL için her zaman 1.
 * Kur bulunamazsa `null` döner — çağıran bunu sessizce 1 saymaz.
 */
export function kuruBul(kayit, birim) {
    const kod = paraBirimiNormalle(birim);
    if (kod === ANA_PARA_BIRIMI)
        return 1;
    const k = kayit?.kurlar?.[kod];
    return typeof k === 'number' && Number.isFinite(k) && k > 0 ? k : null;
}
/**
 * KUR BAYAT MI — kaç gün önceki kur "eski" sayılır.
 *
 * TCMB hafta sonu ve resmî tatilde kur yayımlamaz; cuma akşamı alınan kur
 * pazartesi sabahına kadar en güncel kurdur ve bayat DEĞİLDİR. Bu yüzden
 * sınır 4 gündür: uzun bir bayram tatilini de kapsar, gerçekten unutulmuş
 * bir kuru ise yakalar.
 */
export const KUR_BAYAT_GUN = 4;
export function kurBayatMi(kayit, bugunTarih) {
    if (!kayit)
        return true;
    if (kayit.kaynak === 'tohum')
        return true;
    const a = Date.parse(`${kayit.tarih}T00:00:00Z`);
    const b = Date.parse(`${bugunTarih}T00:00:00Z`);
    if (!Number.isFinite(a) || !Number.isFinite(b))
        return true;
    return (b - a) / 86400000 > KUR_BAYAT_GUN;
}
//# sourceMappingURL=paraBirimi.js.map